import {BaseDevice} from "./base.device";
import {Inject, Injectable} from "@angular/core";
import {TokenService} from "../token/token.service";
import {HttpClient} from "@angular/common/http";
import {UserService} from "../user/user.service";
import {BASE_CLIENT, BaseClient} from "../client/base.client";
import {preloaderFinished} from "../auth/preloader";
import {Itoken} from "../auth/itoken";
import {from, Observable} from "rxjs";
import {IShare, ITitle, IWindow, NavigationBar, UserLocation} from "./model";
import {Title} from "@angular/platform-browser";
import {MyWechatMpToken} from "./model/wechat.mp";


const apis = [
  'requestAuthCode',
  'scan',
  'getLocation',
  'device.geolocation.get',
];


declare let dd;

@Injectable({
  providedIn: "root",
})
export class Dingtalk extends BaseDevice {
  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private user: UserService,
    private title: Title,
    @Inject(BASE_CLIENT) private baseclient: BaseClient
  ) {
    super();
  }

  auth(): Promise<any> {
    if (this.baseclient.dingtalk && this.baseclient.dingtalk.auth === false) {
      return new Promise<any>((resolve, reject) => {
        preloaderFinished();
        resolve(true);
      });
    }
    return new Promise<any>((reject, resolve) => {
      const url = encodeURIComponent(window.location.href);
      this.http
        .get(`${this.baseclient.gateway}/wechat/mp/token?url=` + url)
        .subscribe((token: MyWechatMpToken) => {
          if (token.error_code === 200) {
            this.tokenService.set({
              accessToken: token.message,
              tokenType: "bearer",
            } as any);
            this.http
              .get(`${this.baseclient.gateway}/auth/user`)
              .subscribe((response: any) => {
                this.user.set(response.principal);
                this.generateDingtalkConfig();
                preloaderFinished();
                reject(null);
              });
          } else if (token.error_code === 500) {
            // 没有token，则重定向到认证页面，认证完成后会跳回本页面
            window.location.href = token.path;
          }
        });
    });
  }

  openWindow(iwindow: IWindow): void {
    window.open(iwindow.url, '_self');
  }

  setTitle(ititle: ITitle): void {
    this.title.setTitle(ititle.title);
  }

  setNavigationBar(navigationBar: NavigationBar): void {
    alert("dingtalk暂不支持放置按钮!");
  }

  share(ishare: IShare): void {
    alert("dingtalk暂不支持分享!");
  }

  getToken(): Itoken {
    return this.tokenService.get();
  }

  scanCode(): Observable<string> {
    const p = new Promise<string>(resolve => {
      dd.scan({
        type: 'qr',
        success: (res) => {
          resolve(res.text);
        },
        fail: (err) => {
          console.log('调用扫一扫失败:' + JSON.stringify(err));
        },
      });
    });
    return from(p);
  }

  userLocation(): Observable<UserLocation> {
    const p = new Promise<UserLocation>(resolve => {
      dd.getLocation({
        type: 1,
        useCache: true,
        coordinate: '0',
        cacheTimeout: 20,
        withReGeocode: true,
        targetAccuracy: '200',
        success: (res) => {
          console.log(res);
          const {latitude, longitude, address} = res;
          resolve({latitude, longitude, address});
        },
        fail: (err) => {
          console.log('调用定位失败:' + JSON.stringify(err));
        },
      });
    });
    return from(p);
  }

  validateInWifi(bssids: string[]): Observable<boolean> {
    alert("dingtalk暂不支持WIFI验证!");
    return undefined;
  }

  getWifiMac(): Observable<string> {
    alert("dingtalk暂不支持获取MAC地址!");
    return undefined;
  }

  chooseContacts(count: number): Observable<any> {
    alert("dingtalk暂不支持获取联系人!");
    return undefined;
  }

  contactDetails(targetUserId: string): Observable<any> {
    alert("dingtalk暂不支持查询联系人详细信息!");
    return undefined;
  }

  uploadImage(count: number, sourceType: any): Observable<any> {
    alert("dingtalk暂不支持图片上传!");
    return undefined;
  }

  openReadWithTimer(
    url: any,
    openType: any,
    title: any,
    id: any,
    type: any
  ): Observable<any> {
    alert("dingtalk暂不支持读物时间统计!");
    return undefined;
  }

  uploadMovie(limitMinute: number): Observable<any> {
    alert("dingtalk暂不支持视频上传!");
    return undefined;
  }

  fileBrowser(url: string, title: string): Observable<any> {
    alert("dingtalk暂不支持此功能!");
    return undefined;
  }

  startSearchBeacons(ticket: string, callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }

  stopSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }

  onSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }


  generateDingtalkConfig(): void {
    this.http
      .get(`${this.baseclient.gateway}/wechat/mp/jssdk?url=${encodeURIComponent(window.location.href)}`)
      .subscribe((response: any) => {
        try {
          dd.config({
            agentId: response.agentId, // 必填，微应用ID
            corpId: response.corpId, // 必填，企业ID
            timeStamp: response.timestamp, // 必填，生成签名的时间戳
            nonceStr: response.nonceStr, // 必填，自定义固定字符串。
            signature: response.signature, // 必填，签名
            type: 0,   // 选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
            jsApiList: apis // 必填，需要使用的jsapi列表，注意：不要带dd。
          });
        } catch (e) {
          console.log(e);
        }
      });
    dd.ready(() => {
      console.log('钉钉jssdk初始化完成.');
    });

    dd.error((res) => {
      console.log('钉钉jssdk初始化失败:', res);
    });
  }
}
